import './App.css';
import Certificados from './components/Certificados';
import Contato from './components/Contato';
import Footer from './components/Footer';
import Home from './components/Home';
import Projetos from './components/Projetos';
import Sobre from './components/Sobre';

function App() {
  return (
    <div className="App">
      <Home />
      <Sobre />
      <Projetos />
      <Certificados />
      <Contato />
      <Footer />
    </div>
  );
}

export default App;
